module.exports = __webpack_public_path__ + "img/mappe_di_comunita.0ff50e83.png";